<template>
  <div
      v-if="jobId"
      :class="{
        'bg-gray40': workOrder.isUnfinished,
        'bg-depot': workOrder.isActive,
        'bg-green': workOrder.isCompleted,
      }"
      class="STATUS-PILL d-iflex jc-center ai-center text-md text-bold"
  >
    {{ workOrder.statusName }}
  </div>
</template>

<script>
import workOrder from '@/mixins/work-order';

export default {
  name: 'job-status-badge',
  mixins: [
    workOrder,
  ],
  props: {
    // Used by workOrder mixin
    jobId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .STATUS-PILL {
    @include padding(0 2);
    border-radius: 100px;
    min-width: 100px;
    height: 24px;
    color: white;
    text-transform: uppercase;
  }
</style>
